"use client";

import { useTranslation } from "@/lib/i18n";
import { fallbackLng } from "@/lib/i18n/settings";
import { Plan } from "@/lib/shared/payment/types";
import { Loader2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import RegionTips from "../region-tips/RegionTips";
import PricingPlanSection from "./PricingPlanSection";
import PricingTable from "./PricingTable";
import Background from "./background.svg";

const PricingSection: React.FC<{
  lng?: string;
}> = ({ lng = fallbackLng }) => {
  const { t, i18n } = useTranslation({ ns: "pricing" });

  const [plans, setPlans] = useState<Plan[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchPlans = async (language: string) => {
    setLoading(true);
    try {
      const plansData = await fetch(`/api/payment/plans?lng=${language}`);
      const plans = await plansData.json();
      setLoading(false);
      return plans.data;
    } catch (error) {
      setLoading(false);
      return [];
    }
  };

  useEffect(() => {
    fetchPlans(i18n.language).then((plans) => {
      setPlans(plans);
    });
  }, [i18n.language]);

  return (
    <div className="relative mx-auto max-w-screen-xl">
      <RegionTips className="sticky top-0 z-10 rounded shadow-sm" />
      <Background className="absolute right-0 top-0" />
      <h1 className="mt-24 text-center text-5xl font-semibold leading-normal">
        {t("pricing.description")}
      </h1>

      <p
        className="mt-8 text-center text-neutral-600"
        dangerouslySetInnerHTML={{
          __html: t("pricing.free.for.limited.time.description"),
        }}
      ></p>

      {loading ? (
        <div className="mt-12 flex justify-center">
          <Loader2 className="animate-spin" />
        </div>
      ) : (
        <PricingPlanSection plans={plans} />
      )}

      <PricingTable lng={i18n.language} />
    </div>
  );
};

export default PricingSection;
